// extracted by mini-css-extract-plugin
export default {"App":"App_App__rucfw","switch-wrapper":"App_switch-wrapper__lweo+"};